import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {FilterCriteria} from "../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestListGroupBy} from "../../../../core/shared/dto/object/request/object-request-list-group-by";
import {ObjectRequestListAttribute} from "../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";

@Injectable({
  providedIn: 'root'
})
export class TicketRelTicketService extends MvsCrudService{

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/tm/ticketRelTickets');
  }

  public listSubtasksCount(ticketId: number): Observable<number> {

    const filterCriteria = FilterCriteria.createAnd(
        FilterCriteria.create("ticket", FilterCriteria.cOperatorEqual, ticketId));

    const request: ObjectRequestListGroupBy = ObjectRequestListGroupBy.create(
        false,
        filterCriteria,
        [],
        ["ticket"],
        [new ObjectRequestListAttribute("ticket", "count", DtoListAttributeRequestAggregateEnum.count)]
    );

    return this.groupBy(request).pipe(
        map(result => {
          if (!result || !result.entries || result.entries.length == 0 || !result.entries[0] || !result.entries[0]["ticket_count"]) {
            return 0;
          } else {
            return result.entries[0]["ticket_count"];
          }
        })
    );

  }
}
